import React, { forwardRef } from 'react';
import cn from 'classnames';

import css from 'styles/components/common/card.scss';

// eslint-disable-next-line prefer-arrow-callback
export const Card = forwardRef(function Card(props, ref) {
  const { children, className, ...rest } = props;

  return (
    <article
      ref={ref}
      className={cn(css.card, className)}
      {...rest}>
      {children}
    </article>
  );
});

export default Card;

